import { BaseService } from "services/_baseService";

import appAxios from "services/axios";

export interface PlanLimitUsage {
    code: 'team_members' | 'channels' | 'ai_requests_per_month';
    name: string;
    // null — без ограничений
    limit: number | null;
    used: number;
}

class SubscriptionService extends BaseService<any> {
    constructor() {
        super(`subscriptions`);
    }
    // Использование лимитов тарифа. Пустой массив — у организации нет лимитов
    getUsage() {
        return appAxios.get<PlanLimitUsage[]>(`${this.pathWithOrg()}/usage`);
    }
}

export default new SubscriptionService();